// extracted by mini-css-extract-plugin
export default {"item":"styles_item__Qzqbg","label":"styles_label__Vg95t","content":"styles_content__IFHk6","divider":"styles_divider__AF+7L"};